export default __webpack_public_path__ + "static/media/shopingitem.c87645ca.svg";